import cx from "classnames";
import { useState } from "react";

import { BranchPrefsComposite } from "@/appComponents/Blocks/Composites/BranchPrefsComposite/BranchPrefsComposite";
import { Tabs } from "@theorgchartdev/storybook";
import { PaginationWizardTab } from "@/appComponents/Navigation/RightSidebar/Optimize/PaginationWizardTab";
import { appstr } from "@coreapp/utils/appstr";
import { QXDoc } from "@coreapp/CoreApp/QXDoc";

type OptimizationTabsProps = {
  doc: QXDoc;
};

export const OptimizationTabs = ({ doc }: OptimizationTabsProps) => {
  const [currentTab, setCurrentTab] = useState(0);

  const getTabs = () => {
    const dMgr = doc.GetDocMgr();
    const docPrefs = dMgr?.GetDocPrefs();
    const pageOpt = docPrefs?.GetPageOpt();

    return [
      {
        header: appstr("Pagination wizard"),
        content: <PaginationWizardTab doc={doc} />,
        dataTestId: "optimize-pagination-tab"
      },
      {
        header: appstr("branchstyles"),
        content: <BranchPrefsComposite pageOpt={pageOpt} />,
        dataTestId: "optimize-branch-prefs-tab"
      }
    ];
  };

  return (
    <div className={cx("ocn-chart-explorer-column", "ocn-chart-explorer-tabular")}>
      <Tabs
        tabIndex={currentTab}
        tabs={getTabs()}
        onTabChange={setCurrentTab}
        tabSize={"medium"}
        customClass={"ocn-sidebar-tabs"}
        customHeaderClass={"oc-tab-header-no-divider"}
        customContentClass={"ocn-chart-explorer-tabs-content"}
      />
    </div>
  );
};
